import { useState, useEffect } from "react";
import EvaluationForm from "../evaluationForm";
import moment from "moment";
// Components
import Popup from "../../../../popup";

const UpdateEvaluation = ({
  evaluation,
  evaluationIndex,
  isShowingUpdateEvaluationPopup,
  setIsShowingUpdateEvaluationPopup,
  recharge,
  setRecharge,
}) => {
  const [evaluationDate, setEvaluationDate] = useState("");
  const [evaluationTime, setEvaluationTime] = useState("");
  const [RASS, setRASS] = useState("");
  const [Dyspnoea, setDyspnoea] = useState("");
  const [Pain, setPain] = useState("");
  const [AnxiousSymptomatology, setAnxiousSymptomatology] = useState("");
  const [DepressiveSymptoms, setDepressiveSymptoms] = useState("");
  const [Delirium, setDelirium] = useState("-");
  const [MechanicalVentilation, setMechanicalVentilation] = useState("-");
  const [Position, setPosition] = useState("-");
  const [Sleep, setSleep] = useState("");
  const [Mobility, setMobility] = useState("-");
  const [Observations, setObservations] = useState("-");
  // Handle errors
  const [evaluationTimeError, setEvaluationTimeError] = useState(false);
  const [RASSError, setRASSError] = useState(false);
  const [DyspnoeaError, setDyspnoeaError] = useState(false);
  const [PainError, setPainError] = useState(false);
  const [AnxiousSymptomatologyError, setAnxiousSymptomatologyError] = useState(false);
  const [DepressiveSymptomsError, setDepressiveSymptomsError] = useState(false);
  const [SleepError, setSleepError] = useState(false);

  useEffect(() => {
    setEvaluationDate(moment(evaluation.EVALUATION_DATE).format("YYYY/MM/DD"));
    setEvaluationTime(moment(evaluation.EVALUATION_DATE).format("HH:mm"));
    setRASS(evaluation.RASS);
    setDyspnoea(evaluation.Dyspnoea);
    setPain(evaluation.Pain);
    setAnxiousSymptomatology(evaluation.AnxiousSymptomatology);
    setDepressiveSymptoms(evaluation.DepressiveSymptoms);
    setDelirium(evaluation.Delirium);
    setMechanicalVentilation(evaluation.MechanicalVentilation);
    setPosition(evaluation.Position);
    setSleep(evaluation.Sleep);
    setMobility(evaluation.Mobility);
    setObservations(evaluation.Observations);

    return () => {
      setEvaluationDate("");
      setEvaluationTime("");
      setRASS("");
      setDyspnoea("");
      setPain("");
      setAnxiousSymptomatology("");
      setDepressiveSymptoms("");
      setDelirium("-");
      setMechanicalVentilation("-");
      setPosition("-");
      setSleep("");
      setMobility("-");
      setObservations("-");
    };
  }, [evaluation]);

  return (
    <Popup isShowed={isShowingUpdateEvaluationPopup} setIsShowed={setIsShowingUpdateEvaluationPopup}>
      <EvaluationForm
        type="update"
        evaluation={evaluation}
        evaluationIndex={evaluationIndex}
        evaluationDate={evaluationDate}
        evaluationTime={evaluationTime}
        setEvaluationTime={setEvaluationTime}
        evaluationTimeError={evaluationTimeError}
        setEvaluationTimeError={setEvaluationTimeError}
        RASS={RASS}
        setRASS={setRASS}
        RASSError={RASSError}
        setRASSError={setRASSError}
        Dyspnoea={Dyspnoea}
        setDyspnoea={setDyspnoea}
        DyspnoeaError={DyspnoeaError}
        setDyspnoeaError={setDyspnoeaError}
        Pain={Pain}
        setPain={setPain}
        PainError={PainError}
        setPainError={setPainError}
        AnxiousSymptomatology={AnxiousSymptomatology}
        setAnxiousSymptomatology={setAnxiousSymptomatology}
        AnxiousSymptomatologyError={AnxiousSymptomatologyError}
        setAnxiousSymptomatologyError={setAnxiousSymptomatologyError}
        DepressiveSymptoms={DepressiveSymptoms}
        setDepressiveSymptoms={setDepressiveSymptoms}
        DepressiveSymptomsError={DepressiveSymptomsError}
        setDepressiveSymptomsError={setDepressiveSymptomsError}
        Delirium={Delirium}
        setDelirium={setDelirium}
        MechanicalVentilation={MechanicalVentilation}
        setMechanicalVentilation={setMechanicalVentilation}
        Position={Position}
        setPosition={setPosition}
        Sleep={Sleep}
        setSleep={setSleep}
        SleepError={SleepError}
        setSleepError={setSleepError}
        Mobility={Mobility}
        setMobility={setMobility}
        Observations={Observations}
        setObservations={setObservations}
        setIsShowingEvaluationPopup={setIsShowingUpdateEvaluationPopup}
        recharge={recharge}
        setRecharge={setRecharge}
      />
    </Popup>
  );
};

export default UpdateEvaluation;
